import { FunctionComponent, useState, MutableRefObject } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import layout from "simple-keyboard-layouts/build/layouts/brazilian";
import "./keyboard.css";

interface IProps {
  onChange: (input: string) => void;
  keyboardRef: MutableRefObject<any>;
  typeKeyboard: "brazilian" | "numeric" | "shift";
  onPressEnter: () => void;
  onPressBack: () => void;
}

const KeyboardWrapper: FunctionComponent<IProps> = ({
  onChange,
  keyboardRef,
  typeKeyboard,
  onPressEnter,
  onPressBack,
}) => {
  const [layoutName, setLayoutName] = useState(typeKeyboard);

  const onKeyPress = (button: string) => {
    if (button === "{shift}" || button === "{lock}") {
      setLayoutName(layoutName === "brazilian" ? "shift" : "brazilian");
    }

    if (button === "{back}") {
      onPressBack();
    }
    if (button === "{enter}") {
      setTimeout(() => {
        onPressEnter();
      }, 500);
    }
  };

  return (
    <Keyboard
      keyboardRef={(r) => (keyboardRef.current = r)}
      theme={"hg-theme-default hg-layout-default myTheme"}
      onChange={onChange}
      onKeyPress={onKeyPress}
      onRender={() => console.log("Rendered")}
      display={{
        "{bksp}": "Limpar",
        "{clear}": "Excluir",
        "{enter}": "Entrar",
        "{back}": "Voltar",
      }}
      buttonTheme={[
        {
          class: "hg-green",
          buttons: "{enter}",
        },
        {
          class: "hg-back",
          buttons: "{back}",
        },
      ]}
      onModulesLoaded={() => {
        console.log("Modules loaded!");
      }}
      mergeDisplay
      disableCaretPositioning
      preventMouseDownDefaultbuttonTheme={[
        {
          class: "hg-red",
          buttons: "Q W E R T Y q w e r t y",
        },
        {
          class: "hg-highlight",
          buttons: "Q q",
        },
      ]}
      layoutCandidates={{
        a: "ã â",
        e: "é ê è",
        i: "í",
        c: "ç",
        A: "Ã Â",
        E: "É Ê È",
        I: "Í",
        C: "Ç",
      }}
      layout={
        typeKeyboard === "numeric"
          ? {
              default: [
                "1 2 3",
                "4 5 6",
                "7 8 9",
                "0 {bksp}",
                "{back} {enter}",
              ],
            }
          : {
              ...layout.layout,
              numeric: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 "],
            }
      }
    />
  );
};

export default KeyboardWrapper;
